import { render, staticRenderFns } from "./CartItemsComponent.vue?vue&type=template&id=bb3d468a&scoped=true&"
import script from "./CartItemsComponent.vue?vue&type=script&lang=js&"
export * from "./CartItemsComponent.vue?vue&type=script&lang=js&"
import style0 from "./CartItemsComponent.vue?vue&type=style&index=0&id=bb3d468a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3d468a",
  null
  
)

export default component.exports